import { getFreshGpsPosition } from './activityPosition';

// A diagnostic only: reuse fresh-fix validation, discard coordinates, and never
// invoke a persistence API. Keep the original device code before the completion
// utility replaces it with activity-specific guidance.
export async function checkDeviceLocation(geolocation = navigator.geolocation) {
  if (!geolocation?.getCurrentPosition) return 'unsupported';
  let deviceCode;
  try {
    await getFreshGpsPosition({
      getCurrentPosition: (ok, fail, options) => geolocation.getCurrentPosition(ok, error => {
        deviceCode = error?.code;
        fail(error);
      }, options)
    });
    return 'available';
  } catch {
    return ({ 1: 'denied', 2: 'unavailable', 3: 'timeout' })[deviceCode] || 'unknown';
  }
}
